import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuNavBarComponent } from './menu-nav-bar.component';
import { SharedModule } from '../../shared-module/shared.module';
import { MenuNodeComponent } from './menu-node/menu-node.component';
import { MenuSearchComponent } from './menu-search/menu-search.component';
import { MenuChildNodeComponent } from './menu-node/menu-child-node/menu-child-node.component';
import { MenuParentNodeComponent } from './menu-node/menu-parent-node/menu-parent-node.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [MenuNavBarComponent, MenuNodeComponent, MenuSearchComponent, MenuChildNodeComponent, MenuParentNodeComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  exports:[MenuNavBarComponent]
})
export class MenuNavBarModule{ }